
export enum PatientHomeRouteOptions {
    NONE = '',
    ASSIGNMENTS = 'assignments',
    WEIGHT = 'weight',
    GOAL_WEIGHT = 'goalWeight',
    PRESCRIPTIONS = 'prescriptions',
}
